<template>
    <div v-if="isShow">
      <slot></slot>
    </div>
    <div v-else class="bg_white pt16 pb16 pl16 pr16 ab">アクセスエラー<br>coNPusアプリから再度開き直してください。</div>
  </template>
  
  <script>
  import Check from '@/model/getToken'

  
  export default {
    data() {
      return {
        typeList: [],
        isShow: true,
        sendDay: [],
        dayList: [],
      }
    },
    methods: {
    },
    async created() {
      let res;
      await Check.checkRequest(this.$route.query.code).then((val) => { res = val; });
      if(!res) {
        this.isShow = false;
      }
    },
  }
  </script>
  
  <style lang="css" scoped>
  </style>
  


// WEBPACK FOOTER //
// src/views/common/BaseTemplate.vue